export default [
  {
    title: 'Brands',
    route: 'brands',
    tabIcon: '/svg/tab/MyAds.svg',
    tabIconActive: '/svg/tab/MyAdsWhite.svg',
  },
  {
    title: 'My Ads',
    route: 'my-ads',
    tabIcon: '/svg/tab/MyAds.svg',
    tabIconActive: '/svg/tab/MyAdsWhite.svg',
  },
  {
    title: 'Wallet / Billing',
    route: 'Plan Renewal',
    tabIcon: '/svg/tab/Wallet.svg',
    tabIconActive: '/svg/tab/WalletWhite.svg',
  },
  {
    title: 'Reports',
    route: 'reports',
    tabIcon: '/svg/tab/Reports.svg',
    tabIconActive: '/svg/tab/ReportsWhite.svg',
  },
  {
    title: 'Create Ad',
    route: 'create-ad',
    tabIcon: '/svg/tab/CreateAds.svg',
    tabIconActive: '/svg/tab/CreateAdsWhite.svg',
  },
]
